import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import styles from "../styles/FeaturesContainer.module.scss";
const FeaturesContainer = () => {
  const featuresArray = [
    {
      id: 1,
      heading: "Bridging Loans",
      subHead1: "Rates From 0.44% ",
      subHead2: "10 Days To Complete",
      subHead3: "18 Month Terms",
      link: "/bridgingloans",
    },
    {
      id: 2,
      heading: "Development Finance",
      subHead1: "Rates From 0.34% pm",
      subHead2: "95% LTC & 75% LTGDV",
      subHead3: "Available All UK Covered",
      link: "/developmentfinance",
    },
    {
      id: 3,
      heading: "Stop Repo",
      subHead1: "Rates from 0.85% p/m",
      subHead2: "Loans completed in 24/48Hrs",
      subHead3: "Up to 85% LTV & fees inculded",
      link: "/stoprepossessions",
    },
    {
      id: 4,
      heading: "Auction Finance",
      subHead1: "Rates From 0.44% pm ",
      subHead2: "Up to 85% LTV",
      subHead3: "Loans completed in 5 days",
      link: "/pagenotfound",
    },
  ];
  return (
    <div className={styles.featuresContainer}>
      <p className={styles.header}>Services we provide</p>
      <div className={styles.features}>
        {featuresArray.map((feature) => {
          return (
            <div
              className={classNames(
                styles.feature,
                feature.id === 1
                  ? styles.bLoans
                  : feature.id === 2
                  ? styles.dFinance
                  : feature.id === 3
                  ? styles.sRepo
                  : feature.id === 4
                  ? styles.reSources
                  : ""
              )}
            >
              <p className={styles.head}>{feature.heading}</p>
              <ul className={styles.subhead}>
                <li>{feature.subHead1}</li>
                <li>{feature.subHead2}</li>
                <li>{feature.subHead3}</li>
              </ul>
              <Link
                to={feature.link}
                className={classNames(
                  styles.link,
                  feature.id === 1
                    ? styles.bLoans
                    : feature.id === 2
                    ? styles.dFinance
                    : feature.id === 3
                    ? styles.sRepo
                    : feature.id === 4
                    ? styles.reSources
                    : ""
                )}
              >
                Learn more
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeaturesContainer;
